import Alpine from "alpinejs"

Alpine.data("definitionSlider", (length) => ({
    slide: 0,
    slide_count: length,
    prev() {
        this.slide = (this.slide_count + this.slide - 1) % this.slide_count
    },
    next() {
        this.slide = (this.slide + 1) % this.slide_count
    },
    anchorMatchHandler(element, originalEvent) {
        if (originalEvent.type === "DOMContentLoaded") {
            const index = Array.prototype.indexOf.call(element.parentNode.children, element)
            if (index > 0) {
                this.slide = index
            }
        }
    },
}))
